import Vue from 'vue/dist/vue.esm'
import VueFormWizard from 'vue-form-wizard'
import Vuelidate from 'vuelidate'

Vue.use( Vuelidate )
Vue.use( VueFormWizard )

const {
  required,
  email,
  minLength,
} = require('vuelidate/lib/validators')

document.addEventListener( 'DOMContentLoaded', () => {
  Vue.component( 'create_sponsor', {
    template: `<div>
            <div class="row form-group" v-bind:class="{ 'has-error': $v.sponsor.name.$error }">
              <label class="col-sm-3 col-form-label required font-bold">Sponsor Name</label>
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="sponsor.name" @input="$v.sponsor.name.$touch()">
                <span class="form-text m-b-none">A "Sponsor" sponsors one or more "Issuers" (each fund is an issuer). For example, if Acme Management, LLC is the general partner of Acme Fund, LP, the Sponsor would be Acme Management, LLC and the issuer would be Acme Fund, LP. For private funds, the General Partner of the fund is typically the Sponsor. A Sponsor can sponsor multiple Issuers.</span>

                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.name.$error && !$v.sponsor.name.required">Sponsor name is required</span>
              </div>
            </div>

            <div class="hr-line-dashed" />

            <div class="row form-group" v-bind:class="{ 'has-error': $v.sponsor.phone_number.$error }">
              <div class="col-sm-3">
                <label class="col-form-label required font-bold">Phone Number</label>
              </div>
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="sponsor.phone_number" @input="$v.sponsor.phone_number.$touch()" placeholder="Phone Number">

                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.phone_number.$error && !$v.sponsor.phone_number.required">Phone Number is required</span>
              </div>
            </div>

            <div class="hr-line-dashed" />

            <div class="row form-group" v-bind:class="{ 'has-error': $v.sponsor.address1.$error }">
              <div class="col-sm-3">
                <label class="col-form-label required font-bold">Mailing Address</label>
                <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="This address should be principal place of business for the sponsor / manager.  This address cannot be a PO Box." />
              </div>
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="sponsor.address1" @input="$v.sponsor.address1.$touch()" placeholder="Address 1">

                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.address1.$error && !$v.sponsor.address1.required">Address is required</span>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-sm-9 offset-sm-3">
                <input class="form-control" v-model.trim="sponsor.address2" @input="$v.sponsor.address2.$touch()" placeholder="Address 2">
              </div>
            </div>

            <div class="row form-group" v-bind:class="{ 'has-error': $v.sponsor.country.$error }">
              <div class="col-sm-4 offset-sm-3">
                <select class="form-control" v-model="sponsor.country" @change="$v.sponsor.country.$touch()">
                  <option value="">Select Country</option>
                  <option value="United States">United States</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Brazil">Brazil</option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Central African Republic">Central African Republic</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo">Congo</option>
                  <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Eswatini">Eswatini</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Greece">Greece</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran">Iran</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Korea, North">Korea, North</option>
                  <option value="Korea, South">Korea, South</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Laos">Laos</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldova">Moldova</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="North Macedonia">North Macedonia</option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestine">Palestine</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russia</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syria</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Timor-Leste">Timor-Leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">United Arab Emirates</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vatican City">Vatican City</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                  <option value="Other">Other</option>
                </select>
                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.country.$error && !$v.sponsor.country.required">Country is required</span>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-sm-3 offset-sm-3" v-bind:class="{ 'has-error': $v.sponsor.city.$error }">
                <input class="form-control" v-model.trim="sponsor.city" @input="$v.sponsor.city.$touch()" placeholder="City">
                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.city.$error && !$v.sponsor.city.required">City is required</span>
              </div>

              <div class="col-sm-3" v-bind:class="{ 'has-error': $v.sponsor.state.$error }">
                <input class="form-control" v-model.trim="sponsor.state" @input="$v.sponsor.state.$touch()" placeholder="State/Province/Region">
              </div>

              <div class="col-sm-3" v-bind:class="{ 'has-error': $v.sponsor.zip.$error }">
                <input class="form-control" v-model.trim="sponsor.zip" @input="$v.sponsor.zip.$touch()" :placeholder="sponsor.country === 'United States' ? 'Zip Code' : 'Postal Code'">
                <span class="help-block" style="color: #ED5565;" v-if="$v.sponsor.zip.$error && !$v.sponsor.zip.required">{{ sponsor.country === 'United States' ? 'Zip code' : 'Postal code' }} is required</span>
              </div>
            </div>
          </div>`,
    data() {
      return {
        sponsor: {
          name: '',
          phone_number: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: '',
          country: 'United States'
        },
      }
    },
    validations: {
      sponsor: {
        name:     { required },
        phone_number: { required },
        address1: { required },
        address2: { },
        city:     { required },
        state:    { },
        zip:      { required },
        country:  { required },
      },
      form: [ 'sponsor.name', 'sponsor.phone_number', 'sponsor.address1', 'sponsor.address2', 'sponsor.city', 'sponsor.state', 'sponsor.zip', 'sponsor.country' ]
    },
    methods: {
      validate() {
        this.$v.form.$touch()
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
    }
  })

  Vue.component( 'create_issuer', {
    template: `<div>
            <div class="row form-group" v-bind:class="{ 'has-error': $v.issuer.name.$error }">
              <label class="col-sm-4 col-form-label required font-bold">Issuer Name</label>
              <div class="col-sm-8">
                <input class="form-control" v-model.trim="issuer.name" @input="$v.issuer.name.$touch()">
                <span class="form-text m-b-none">A "Sponsor" sponsors multiple "Issuers". If Acme Management, LLC manages Acme Fund, LP, the Issuer would be Acme Fund, LP.</span>

                <span class="help-block" style="color: #ED5565;" v-if="$v.issuer.name.$error && !$v.issuer.name.required">Issuer name is required</span>
              </div>
            </div>

            <div class="row form-group" v-bind:class="">
              <label class="col-sm-4 col-form-label required font-bold">Has this Issuer ever made a Form D Filing?</label>
              <div class="col-sm-8">
                <select class="form-control" style="max-width: 100px;" v-model="issuer.has_made_form_d_filing" @change="$v.issuer.has_made_form_d_filing.$touch()">
                  <option value></option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <span class="help-block" style="color: #ED5565;" v-if="$v.issuer.has_made_form_d_filing.$error && !$v.issuer.has_made_form_d_filing.required">Please let us know if this issuer has ever made a Form D Filing</span>
              </div>
            </div>

<!--
            <div v-if="issuer.has_made_form_d_filing == 'No' && showTooltips">
              <div class="hr-line-dashed" />
              <span class="help-block" style="color: #ED5565; font-weight: bold;">If this issuer has never made a Form D Filing, please provide us with the information below so that we can prepare a Form ID for the Issuer immediately</span>

              <br/>
              <br/>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">"Doing Business As" Name</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="Complete this section only if the issuer is utilizing a DBA; otherwise leave blank" />
                </div>
                <div class="col-sm-8">
                  <input class="form-control" v-model.trim="issuer.dba_name">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">Foreign Name</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="Complete this field only if the name of your company is in a language other than English" />
                </div>
                <div class="col-sm-8">
                  <input class="form-control" v-model.trim="issuer.foreign_name">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">State of Incorporation</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="This is the State in which the Issuer was formed (not where the business is based)" />
                </div>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.state_of_incorporation">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">Fiscal Year End (MM/DD)</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="All entities that are taxed as partnerships typically have a 12/31 Fiscal Year -- but check with your CPA if you are not clear about this point" />
                </div>
                <div class="col-sm-2">
                  <input class="form-control" v-model.trim="issuer.fiscal_year_end">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">Tax ID of Issuer</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="This is your US Federal EIN; if you do not have an EIN, enter '0'" />
                </div>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.tax_id">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">Primary Contact at Issuer</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="This is the first and last name of the person who is authorized to sign the Form D on behalf of the Issuer" />
                </div>
                <div class="col-sm-4">
                  <input class="form-control" v-model.trim="issuer.primary_contact">
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <label class="col-form-label">Title of Primary Contact</label>
                  <i class="fas fa-question-circle m-l" rel="tooltip" title= "" data-toggle="tooltip" data-placement="right" data-original-title="This should be a basic title; the field is limited to 150 characters on Form D" />
                </div>
                <div class="col-sm-3">
                  <input class="form-control" maxlength="150" v-model.trim="issuer.primary_contact_title">
                </div>
              </div>
            </div>

            <div v-if="issuer.has_made_form_d_filing == 'Yes' && showTooltips">
              <div class="hr-line-dashed" />
              <span class="help-block" style="color: #ED5565; font-weight: bold;">If this issuer has made a Form D Filing, please provide us with the following values. If you do not know these fields, you can still submit the form, and we will work with you to gather them.</span>

              <br/>
              <br/>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">CIK code</label>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.edgar_cik">
                </div>
              </div>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">Password</label>
                <div class="col-sm-3">
                  <input class="form-control" type="password" v-model.trim="issuer.edgar_password">
                </div>
              </div>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">CCC</label>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.edgar_ccc">
                </div>
              </div>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">PMAC</label>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.edgar_pmac">
                </div>
              </div>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">Passphrase</label>
                <div class="col-sm-3">
                  <input class="form-control" type="password" v-model.trim="issuer.edgar_passphrase">
                </div>
              </div>

              <div class="row form-group">
                <label class="col-sm-4 col-form-label">Accession Number</label>
                <div class="col-sm-3">
                  <input class="form-control" v-model.trim="issuer.edgar_accession_number">
                </div>
              </div>
            </div>
-->

            <br/>
          </div>`,
    data() {
      return {
        issuer: {
          name: '',
          has_made_form_d_filing: ''
        }
      }
    },
    computed: {
      showTooltips: function( ) {
        // function must reference has_mode_form_d_filing, so that function return value isn't cached, and showTooltips( ) is called whenever has_made_form_d_filing is toggled
        if( this.issuer.has_made_form_d_filing ) {
          Vue.nextTick( function( ) {
              $( "[rel='tooltip']" ).tooltip( );
          });
        }

        return true;
      }
    },
    validations( ) {
      return {
        issuer: {
          name: { required },
          has_made_form_d_filing: { required },
        },
        form: [ 'issuer.name', 'issuer.has_made_form_d_filing' ]
      }
    },
    methods: {
      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
    }
  })

  Vue.component( 'invite_sponsor_manager', {
    template: `<div>
            <div class="row form-group" v-bind:class="{ 'has-error': $v.invitation.manager_email.$error }">
              <label class="col-sm-4 col-form-label required font-bold">Sponsor Contact Email</label>
              <div class="col-sm-7">
                <input class="form-control" v-model.trim="invitation.manager_email" @input="$v.invitation.manager_email.$touch()">
                <span class="form-text m-b-none">In order to create a new Sponsor, you must provide us contact information for someone at that Sponsor. We will contact this person at the email address provided, and invite them to create an account.</span>

                <span class="help-block" style="color: #ED5565;" v-if="$v.invitation.manager_email.$error && !$v.invitation.manager_email.required">An email for a Sponsor contact is required</span>
              </div>
            </div>

            <div class="row form-group mt-4" v-bind:class="{ 'has-error': $v.invitation.manager_first_name.$error }">
              <label class="col-sm-4 col-form-label required font-bold">Sponsor Contact First Name</label>
              <div class="col-sm-4">
                <input class="form-control" v-model.trim="invitation.manager_first_name" @input="$v.invitation.manager_first_name.$touch()">

                <span class="help-block" style="color: #ED5565;" v-if="$v.invitation.manager_first_name.$error && !$v.invitation.manager_first_name.required">First name for a Sponsor contact is required</span>
              </div>
            </div>

            <div class="row form-group" v-bind:class="{ 'has-error': $v.invitation.manager_last_name.$error }">
              <label class="col-sm-4 col-form-label required font-bold">Sponsor Contact Last Name</label>
              <div class="col-sm-4">
                <input class="form-control" v-model.trim="invitation.manager_last_name" @input="$v.invitation.manager_last_name.$touch()">

                <span class="help-block" style="color: #ED5565;" v-if="$v.invitation.manager_last_name.$error && !$v.invitation.manager_last_name.required">Last name for a Sponsor contact is required</span>
              </div>
            </div>
          </div>`,
    data() {
      return {
        invitation: {
          manager_email: '',
          manager_first_name: '',
          manager_last_name: ''
        },
      }
    },
    validations( ) {
      return {
        invitation: {
          manager_email: { required, email },
          manager_first_name: { required },
          manager_last_name: { required }
        },
        form: [ 'invitation.manager_email', 'invitation.manager_first_name', 'invitation.manager_last_name' ]
      }
    },
    methods: {
      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
    }
  })

  Vue.component( 'terms_of_use', {
    template: `<div>
              <iframe src="https://portal.blueskycompliance.com/terms_raw" style="width: 100%; min-height: 500px;">
              </iframe>

            <div class="row form-group m-l m-t m-b">
              <div class="col-sm-1" v-bind:class="{ 'has-error': $v.agreement.user_agreement_signature.$error }">
                <label class="col-form-label font-bold">Signed:</label>
              </div>
              <div class="col-sm-8" v-bind:class="{ 'has-error': $v.agreement.user_agreement_signature.$error }">
                <input class="form-control" v-model.trim="agreement.user_agreement_signature" @input="$v.agreement.user_agreement_signature.$touch()" placeholder="Type your name as a signature">
                <span class="form-text m-b-none">By typing your name, you are confirming that you have read and agree to the license agreement.</span>

                <span class="help-block" style="color: #ED5565;" v-if="$v.agreement.user_agreement_signature.$error && !$v.agreement.user_agreement_signature.required">You must agree to the Terms and Conditions by signing your name</span>
              </div>
            </div>

            <div class="row form-group m-l m-t m-b">
              <div class="col-sm-1" v-bind:class="{ 'has-error': $v.agreement.user_agreement_signature_date.$error }">
                <label class="col-form-label font-bold">Dated:</label>
              </div>
              <div class="col-sm-8" v-bind:class="{ 'has-error': $v.agreement.user_agreement_signature_date.$error }">
                <input class="form-control" v-model.trim="agreement.user_agreement_signature_date" @input="$v.agreement.user_agreement_signature_date.$touch()">
                <span class="help-block" style="color: #ED5565;" v-if="$v.agreement.user_agreement_signature_date.$error && !$v.agreement.user_agreement_signature_date.required">You must date your signature</span>
              </div>
            </div>


<!--            <div class="i-checks">
              <label>
                <div class="icheckbox_square-green" style="position: relative;">
                  <input type="checkbox" value="" style="position: absolute; opacity: 0;">
                  <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                </div>
                <i></i> I have read and agree to the license agreement
              </label>
            </div>-->
          </div>`,
    data() {
      return {
        agreement: {
          user_agreement_signature: '',
          user_agreement_signature_date: ( new Date( )).toLocaleString( 'en-US', { month: 'long', day: 'numeric', year: 'numeric' })
        }
      }
    },
    validations: {
      agreement: {
        user_agreement_signature: { required },
        user_agreement_signature_date: { required }
      },
      form: [ 'agreement.user_agreement_signature', 'agreement.user_agreement_signature_date' ]
    },
    methods: {
      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
    }
  })

  const app = new Vue({
    el: '#vue_sponsor_issuer_wizard_validate',
    data: {
      finalModel: { },
    },
    methods: {
      onComplete( ) {
        $( '.wizard-footer-right button' ).prop( 'disabled', true );

        var csrfToken = $( 'meta[name=csrf-token]' )[0].content;
        var httpVars = Object.assign( {}, this.finalModel, { authenticity_token: csrfToken, utf8: "�~\~S" });

        this.postWith( '/portal/sponsors/create_sponsor_issuer', httpVars );
      },
      postWith( to, p ) {
        var myForm = document.createElement( 'form' );
        myForm.method = 'post';
        myForm.action = to;

        for( var k in p ) {
          var ele = p[k];

          if( typeof( ele ) === 'object' ) {
            for( var l in ele ) {
              var myInput = document.createElement( 'input' );
              myInput.setAttribute( 'name', k + '[' + l + ']' );
              myInput.setAttribute( 'value', ele[l] );
              myForm.appendChild( myInput );
            }
          } else {
            var myInput = document.createElement( 'input' );
            myInput.setAttribute( 'name', k );
            myInput.setAttribute( 'value', p[k] );
            myForm.appendChild( myInput );
          }
        }
        document.body.appendChild( myForm );
        myForm.submit( );
        document.body.removeChild( myForm );
      },
      validateStep( name ) {
        var refToValidate = this.$refs[name];
        return refToValidate.validate( );
      },
      mergePartialModels( model, isValid ) {
        if( isValid ) {
        // merging each step model into the final model
          this.finalModel = Object.assign({},this.finalModel, model)
        }
      }
    }
  })
})

